/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ChangePasswordDto,
  GetUserReportsParams,
  GetUsersParams,
  UserDto,
  UserPartialUpdateRequest,
  UserReportDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_CLIENT_SERVICE, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getUsers = (
  userId: string,
  params?: GetUsersParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserDto[]>(
    { url: `/api/${userId}/users`, method: 'GET', params, signal },
    options
  );
};

export const getGetUsersQueryKey = (
  userId: string,
  params?: GetUsersParams
) => {
  return [`/api/${userId}/users`, ...(params ? [params] : [])] as const;
};

export const getGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUsersQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
    signal,
  }) => getUsers(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError = ErrorType<unknown>;

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: undefined | GetUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUsersQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update user. Only ROLE_SUPER_ADMIN can edit other users.</br></br>Authorities: **Any authenticated role**
 */
export const updateUser = (
  userId: string,
  userDto: BodyType<UserDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserDto>(
    {
      url: `/api/${userId}/users`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: userDto,
      signal,
    },
    options
  );
};

export const getUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { userId: string; data: BodyType<UserDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { userId: string; data: BodyType<UserDto> },
  TContext
> => {
  const mutationKey = ['updateUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    { userId: string; data: BodyType<UserDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUser>>
>;
export type UpdateUserMutationBody = BodyType<UserDto>;
export type UpdateUserMutationError = ErrorType<unknown>;

export const useUpdateUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUser>>,
      TError,
      { userId: string; data: BodyType<UserDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { userId: string; data: BodyType<UserDto> },
  TContext
> => {
  return useMutation(getUpdateUserMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />Create User
 */
export const createUser = (
  userId: string,
  userDto: BodyType<UserDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserDto>(
    {
      url: `/api/${userId}/users`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userDto,
      signal,
    },
    options
  );
};

export const getCreateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { userId: string; data: BodyType<UserDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { userId: string; data: BodyType<UserDto> },
  TContext
> => {
  const mutationKey = ['createUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { userId: string; data: BodyType<UserDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return createUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUser>>
>;
export type CreateUserMutationBody = BodyType<UserDto>;
export type CreateUserMutationError = ErrorType<unknown>;

export const useCreateUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUser>>,
      TError,
      { userId: string; data: BodyType<UserDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { userId: string; data: BodyType<UserDto> },
  TContext
> => {
  return useMutation(getCreateUserMutationOptions(options), queryClient);
};
/**
 * Authorities: **Any authenticated role**
 */
export const logoutUser = (
  userId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/${userId}/users/logout`, method: 'POST', signal },
    options
  );
};

export const getLogoutUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutUser>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['logoutUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return logoutUser(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutUser>>
>;

export type LogoutUserMutationError = ErrorType<unknown>;

export const useLogoutUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logoutUser>>,
      TError,
      { userId: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof logoutUser>>,
  TError,
  { userId: string },
  TContext
> => {
  return useMutation(getLogoutUserMutationOptions(options), queryClient);
};
/**
 * Authorities: **Any authenticated role**
 */
export const changeUserPassword = (
  userId: string,
  changePasswordDto: BodyType<ChangePasswordDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${userId}/users/change-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changePasswordDto,
      signal,
    },
    options
  );
};

export const getChangeUserPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeUserPassword>>,
    TError,
    { userId: string; data: BodyType<ChangePasswordDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeUserPassword>>,
  TError,
  { userId: string; data: BodyType<ChangePasswordDto> },
  TContext
> => {
  const mutationKey = ['changeUserPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeUserPassword>>,
    { userId: string; data: BodyType<ChangePasswordDto> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return changeUserPassword(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeUserPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeUserPassword>>
>;
export type ChangeUserPasswordMutationBody = BodyType<ChangePasswordDto>;
export type ChangeUserPasswordMutationError = ErrorType<unknown>;

export const useChangeUserPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changeUserPassword>>,
      TError,
      { userId: string; data: BodyType<ChangePasswordDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof changeUserPassword>>,
  TError,
  { userId: string; data: BodyType<ChangePasswordDto> },
  TContext
> => {
  return useMutation(
    getChangeUserPasswordMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const getUserById = (
  userId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserDto>(
    { url: `/api/${userId}/users/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetUserByIdQueryKey = (userId: string, id: number) => {
  return [`/api/${userId}/users/${id}`] as const;
};

export const getGetUserByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserByIdQueryKey(userId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({
    signal,
  }) => getUserById(userId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserById>>
>;
export type GetUserByIdQueryError = ErrorType<unknown>;

export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          Awaited<ReturnType<typeof getUserById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserByIdQueryOptions(userId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const deleteUser = (
  userId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/${userId}/users/${id}`, method: 'DELETE', signal },
    options
  );
};

export const getDeleteUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { userId: string; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { userId: string; id: number },
  TContext
> => {
  const mutationKey = ['deleteUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { userId: string; id: number }
  > = (props) => {
    const { userId, id } = props ?? {};

    return deleteUser(userId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = ErrorType<unknown>;

export const useDeleteUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUser>>,
      TError,
      { userId: string; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { userId: string; id: number },
  TContext
> => {
  return useMutation(getDeleteUserMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE**<br /><br />Partially update a client user. Only ROLE_FD_PRINCIPAL and ROLE_FD_CLIENT_SERVICE; target must be ROLE_USER or ROLE_INTERNAL_USER. Absent fields are left unchanged; a null or blank jobTitle clears it. Not allowed while impersonating another user.
 */
export const partialUpdateUser = (
  userId: string,
  id: number,
  userPartialUpdateRequest: BodyType<UserPartialUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserDto>(
    {
      url: `/api/${userId}/users/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: userPartialUpdateRequest,
      signal,
    },
    options
  );
};

export const getPartialUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partialUpdateUser>>,
    TError,
    { userId: string; id: number; data: BodyType<UserPartialUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof partialUpdateUser>>,
  TError,
  { userId: string; id: number; data: BodyType<UserPartialUpdateRequest> },
  TContext
> => {
  const mutationKey = ['partialUpdateUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof partialUpdateUser>>,
    { userId: string; id: number; data: BodyType<UserPartialUpdateRequest> }
  > = (props) => {
    const { userId, id, data } = props ?? {};

    return partialUpdateUser(userId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PartialUpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof partialUpdateUser>>
>;
export type PartialUpdateUserMutationBody = BodyType<UserPartialUpdateRequest>;
export type PartialUpdateUserMutationError = ErrorType<unknown>;

export const usePartialUpdateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof partialUpdateUser>>,
      TError,
      { userId: string; id: number; data: BodyType<UserPartialUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof partialUpdateUser>>,
  TError,
  { userId: string; id: number; data: BodyType<UserPartialUpdateRequest> },
  TContext
> => {
  return useMutation(getPartialUpdateUserMutationOptions(options), queryClient);
};
/**
 * Get the reports the user has access to</br></br>Authorities: **Any authenticated role**
 */
export const getUserReports = (
  userId: string,
  params: GetUserReportsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserReportDto[]>(
    { url: `/api/${userId}/users/reports`, method: 'GET', params, signal },
    options
  );
};

export const getGetUserReportsQueryKey = (
  userId: string,
  params?: GetUserReportsParams
) => {
  return [`/api/${userId}/users/reports`, ...(params ? [params] : [])] as const;
};

export const getGetUserReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: GetUserReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserReports>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserReportsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserReports>>> = ({
    signal,
  }) => getUserReports(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserReports>>
>;
export type GetUserReportsQueryError = ErrorType<unknown>;

export function useGetUserReports<
  TData = Awaited<ReturnType<typeof getUserReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: GetUserReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserReports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReports>>,
          TError,
          Awaited<ReturnType<typeof getUserReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReports<
  TData = Awaited<ReturnType<typeof getUserReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: GetUserReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserReports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserReports>>,
          TError,
          Awaited<ReturnType<typeof getUserReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserReports<
  TData = Awaited<ReturnType<typeof getUserReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: GetUserReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserReports>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUserReports<
  TData = Awaited<ReturnType<typeof getUserReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: GetUserReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserReports>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserReportsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Any authenticated role**
 */
export const getCurrentAccount = (
  userId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<UserDto>(
    { url: `/api/${userId}/account`, method: 'GET', signal },
    options
  );
};

export const getGetCurrentAccountQueryKey = (userId: string) => {
  return [`/api/${userId}/account`] as const;
};

export const getGetCurrentAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentAccount>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrentAccountQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentAccount>>
  > = ({ signal }) => getCurrentAccount(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentAccount>>
>;
export type GetCurrentAccountQueryError = ErrorType<unknown>;

export function useGetCurrentAccount<
  TData = Awaited<ReturnType<typeof getCurrentAccount>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentAccount>>,
          TError,
          Awaited<ReturnType<typeof getCurrentAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrentAccount<
  TData = Awaited<ReturnType<typeof getCurrentAccount>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentAccount>>,
          TError,
          Awaited<ReturnType<typeof getCurrentAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrentAccount<
  TData = Awaited<ReturnType<typeof getCurrentAccount>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCurrentAccount<
  TData = Awaited<ReturnType<typeof getCurrentAccount>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCurrentAccountQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
